import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const endpoints = {
  family: () => api.get("/family").then((r) => r.data),
  events: () => api.get("/events").then((r) => r.data),
  createEvent: (payload) => api.post("/events", payload).then((r) => r.data),
  deleteEvent: (id) => api.delete(`/events/${id}`).then((r) => r.data),
  todos: () => api.get("/todos").then((r) => r.data),
  createTodo: (payload) => api.post("/todos", payload).then((r) => r.data),
  updateTodo: (id, payload) => api.patch(`/todos/${id}`, payload).then((r) => r.data),
  deleteTodo: (id) => api.delete(`/todos/${id}`).then((r) => r.data),
  grocery: () => api.get("/grocery").then((r) => r.data),
  createGrocery: (payload) => api.post("/grocery", payload).then((r) => r.data),
  updateGrocery: (id, payload) => api.patch(`/grocery/${id}`, payload).then((r) => r.data),
  deleteGrocery: (id) => api.delete(`/grocery/${id}`).then((r) => r.data),
  clearCheckedGrocery: () => api.post("/grocery/clear-checked").then((r) => r.data),
  weather: () => api.get("/weather").then((r) => r.data),
  calendarStatus: () => api.get("/oauth/calendar/status").then((r) => r.data),
  calendarLoginUrl: () => api.get("/oauth/calendar/login").then((r) => r.data),
  calendarDisconnect: () => api.post("/oauth/calendar/disconnect").then((r) => r.data),
  contacts: () => api.get("/contacts").then((r) => r.data),
  createContact: (payload) => api.post("/contacts", payload).then((r) => r.data),
  deleteContact: (id) => api.delete(`/contacts/${id}`).then((r) => r.data),
  sendGrocery: (payload) => api.post("/grocery/send", payload).then((r) => r.data),
  quotes: () => api.get("/quotes").then((r) => r.data),
  getNotepad: () => api.get("/notepad").then((r) => r.data),
  saveNotepad: (payload) => api.put("/notepad", payload).then((r) => r.data),
};
